import React, { useState, useEffect, useRef, use } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Grid,
  Typography,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Paper,
  Card,
  CardContent,
} from "@mui/material";
import {
  Star,
  ArrowBack,
  Business,
  Person,
  LocationOn,
  CheckCircle,
  Cancel,
  Info,
  Payment,
  LocalShipping,
  Verified,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import CModal from "../../../Components/CModal";
import CButton from "../../../Components/CButton";
import CInput from "../../../Components/CInput";
import styles from "./styles";
import BaseColor from "../../../Config/Color";
import MiniDrawer from "../../../Components/Drawer";
import theme, { FontFamily } from "../../../Config/theme";
import ReactCountryFlag from "react-country-flag";
import CPreviewModal from "../../../Components/CPreviewModal";
import { getApiData, putApiData } from "../../../Apis/apiHelper";
import BaseSetting from "../../../Apis/setting";
// Static data for a single company user

export default function UserDetail() {
  const navigate = useNavigate();
  const classes = styles();
  const [searchParams] = useSearchParams();
  const [pageLoad, setPageLoad] = useState(true);
  const [userDetail, setUserDetail] = useState({});
  const [readMore, setReadMore] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [yesBtnLoading, setYesBtnLoading] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectText, setRejectText] = useState("");
  const [rejectErrorText, setRejectErrorText] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);
  const [approveBtnLoading, setApproveBtnLoading] = useState(false);
  const [rejectBtnLoading, setRejectBtnLoading] = useState(false);
  const [activeImg, setActiveImg] = useState(0);

  const previewModalRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      setPageLoad(false);
    }, 1000);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);



  const getUserDetail = () => {
    const id = searchParams.get("id");

    if (id) {
      const endpoint = `${BaseSetting.endpoint.getUserById}/${id}`;
      getApiData(endpoint, "GET", {})
        .then((res) => {
          console.log("res ==>>", res);
          if (res?.status) {
            console.log(res?.data);
            setUserDetail(res?.data);
          }
        });
    }
  };

  const updateUserApproval = async (action) => {
    const id = searchParams.get("id");
    const payload = { action };
    const endpoint = `${BaseSetting.endpoint.updateUserApproval}/${id}`;

    setApproveBtnLoading(true);

    try {
      const res = await putApiData(endpoint, payload);
      if (res?.status) {
        toast(`${res?.message}`, { type: "success" });
        getUserDetail(); // Refresh data
      } else {
        toast("Failed to update user approval", { type: "error" });
      }
    } catch (err) {
      toast("Error updating user approval", { type: "error" });
    } finally {
      setApproveBtnLoading(false);
    }
  };

  useEffect(() => {
    getUserDetail();
  }, []);

  const deleteUser = () => {
    setYesBtnLoading(true);
    // Simulate API call
    setTimeout(() => {
      toast("User deleted successfully", { type: "success" });
      setYesBtnLoading(false);
      setConfirm(false);
      navigate("/company-users");
    }, 1000);
  };

  const approveUser = () => {
    setApproveBtnLoading(true);
    setDisableBtn(true);
    setTimeout(() => {
      toast("User approved successfully", { type: "success" });
      setApproveBtnLoading(false);
      setDisableBtn(false);
      // setUserDetail({
      //   ...userDetail?,
      //   status: "active",
      // });
    }, 1500);
  };

  const rejectUser = () => {
    setRejectBtnLoading(true);
    setDisableBtn(true);
    setTimeout(() => {
      toast("User rejected successfully", { type: "success" });
      setRejectBtnLoading(false);
      setDisableBtn(false);
      setRejectModal(false);
      setRejectText("");
      // setUserDetail({
      //   ...userDetail?,
      //   status: "inactive",
      // });
    }, 1500);
  };

  const validateRejectReason = () => {
    if (rejectText?.trim() === "" || rejectText === undefined) {
      setRejectErrorText("Reject reason is required");
      return false;
    }
    setRejectErrorText("");
    return true;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Invalid Date";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  const renderImageGallery = () => {
    const images = userDetail?.businessInfo?.company_photoes || [];

    return (
      <Grid item xs={12} md={6} lg={6}>
        <Card className={classes.formSection} elevation={2}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={2}>
              <Business color="primary" />
              <Typography variant="h6" className={classes.sectionTitle} ml={1}>
                Company Gallery
              </Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />

            {images.length > 0 ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (images[activeImg]) {
                      previewModalRef?.current?.open(images[activeImg]);
                    }
                  }}
                >
                  <img
                    src={
                      images[activeImg] ||
                      "https://via.placeholder.com/400x300?text=No+Image"
                    }
                    alt="Company"
                    style={{
                      width: "100%",
                      height: 300,
                      objectFit: "contain",
                      borderRadius: 8,
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    overflowX: "auto",
                    pb: 1,
                    "&::-webkit-scrollbar": {
                      height: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: BaseColor.primary,
                      borderRadius: "6px",
                    },
                  }}
                >
                  {images?.map((image, index) => (
                    <Box
                      key={index}
                      sx={{
                        border:
                          activeImg === index
                            ? `2px solid ${BaseColor.primary}`
                            : "2px solid transparent",
                        borderRadius: 1,
                        overflow: "hidden",
                        cursor: "pointer",
                        minWidth: 80,
                        height: 80,
                      }}
                      onClick={() => setActiveImg(index)}
                    >
                      <img
                        src={image}
                        alt={`Thumbnail ${index}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              </>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 200,
                  backgroundColor: "#f5f5f5",
                  borderRadius: 2,
                }}
              >
                <Typography variant="body1" color="text.secondary">
                  No images available
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>

        <Card className={classes.formSection} elevation={2} sx={{ mt: 3 }}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={2}>
              <Info color="primary" />
              <Typography variant="h6" className={classes.sectionTitle} ml={1}>
                Status Information
              </Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.labelText}>
                  Verification Status
                </Typography>
                <Chip
                  icon={Number(userDetail?.is_verified) === 1 ? <CheckCircle /> : <Cancel />}
                  label={Number(userDetail?.is_verified) === 1 ? "Verified" : "Not Verified"}
                  color={Number(userDetail?.is_verified) === 1 ? "success" : "default"}
                  sx={{ mt: 1 }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.labelText}>
                  Account Status
                </Typography>
                <Chip
                  label={
                    userDetail?.approval_status === "approved"
                      ? "Approved"
                      : userDetail?.approval_status === "rejected"
                        ? "Rejected"
                        : userDetail?.approval_status === "pending"
                          ? "Pending"
                          : "Pending"
                  }
                  color={
                    userDetail?.approval_status === "approved"
                      ? "success"
                      : userDetail?.approval_status === "rejected"
                        ? "error"
                        : userDetail?.approval_status === "pending"
                          ? "warning"
                          : "info"
                  }
                  sx={{ mt: 1 }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.labelText}>
                  Subscription
                </Typography>
                <Chip
                  label={userDetail?.subscription_status}
                  color={
                    userDetail?.subscription_status === "Premium"
                      ? "primary"
                      : userDetail?.subscription_status === "Gold"
                        ? "warning"
                        : "default"
                  }
                  sx={{ mt: 1 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" className={classes.labelText}>
                  Date Created
                </Typography>
                <Typography variant="body2">
                  {formatDate(userDetail?.createdAt)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" className={classes.labelText}>
                  Last Updated
                </Typography>
                <Typography variant="body2">
                  {formatDate(userDetail?.updatedAt)}
                </Typography>
              </Grid>
            </Grid>

            {userDetail?.approval_status === "pending" && (
              <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
                <CButton
                  variant="contained"
                  fullWidth
                  onClick={() => updateUserApproval("approve")}
                  loading={approveBtnLoading}
                  disabled={disableBtn}
                >
                  Approve User
                </CButton>
                <CButton
                  variant="outlined"
                  fullWidth
                  onClick={() => updateUserApproval("reject")}
                  loading={rejectBtnLoading}
                  disabled={disableBtn}
                >
                  Reject User
                </CButton>
              </Box>
            )}
          </CardContent>
        </Card>
      </Grid>
    );
  };

  const renderCompanyInfo = () => {
    return (
      <Grid item xs={12} md={6} lg={6}>
        <Card className={classes.formSection} elevation={2}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={2}>
              <Person color="primary" />
              <Typography variant="h6" className={classes.sectionTitle} ml={1}>
                Basic Information
              </Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12}>
                2
                <Typography className={classes.labelText}>
                  Company Name
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.businessInfo?.name}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  Owner Name
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.first_name}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography className={classes.labelText}>Country</Typography>
                  <ReactCountryFlag
                    countryCode={userDetail?.phone_code_id}
                    svg
                    style={{ width: "20px", height: "20px" }}
                    title={userDetail?.country}
                  />
                </Box>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.country}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>Email</Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.email}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>Phone</Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.phone}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  Mobile Number
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.mobile_number}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>Address</Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.businessInfo?.full_user_address}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography className={classes.labelText}>
                  Business Type
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                  {userDetail?.business_type?.map((type, index) => (
                    <Chip key={index} label={type} size="small" />
                  ))}
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card className={classes.formSection} elevation={2} sx={{ mt: 3 }}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={2}>
              <Business color="primary" />
              <Typography variant="h6" className={classes.sectionTitle} ml={1}>
                Company Details
              </Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography className={classes.labelText}>
                  About Company
                </Typography>
                <Typography
                  variant="body2"
                  className={classes.valueText}
                  paragraph
                >
                  {readMore
                    ? userDetail?.businessInfo?.company_description
                    : userDetail?.businessInfo?.company_description?.slice(0, 200)}
                  {userDetail?.businessInfo?.company_description?.length > 200 && (
                    <Button
                      size="small"
                      onClick={() => setReadMore(!readMore)}
                      sx={{ ml: 1, minWidth: "auto", p: 0 }}
                    >
                      {readMore ? "Show less" : "Read more..."}
                    </Button>
                  )}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography className={classes.labelText}>
                  Why Choose Us
                </Typography>
                <Typography variant="body2" className={classes.valueText}>
                  {userDetail?.businessInfo?.why_choose_us}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  Total Employees
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.businessInfo?.total_no_of_employee}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  Annual Turnover
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.businessInfo?.annual_turn_over}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  Founding Year
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.businessInfo?.company_founding_year}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  Legal Status
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.businessInfo?.legal_status_of_firm}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card className={classes.formSection} elevation={2} sx={{ mt: 3 }}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={2}>
              <Info color="primary" />
              <Typography variant="h6" className={classes.sectionTitle} ml={1}>
                Additional Information
              </Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  GST Number
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.businessInfo?.GST_number}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  GST Partner Name
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.businessInfo?.GST_partner_name}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  GST Registration Date
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {formatDate(userDetail?.businessInfo?.GST_registration_date)}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.labelText}>
                  Import/Export Code
                </Typography>
                <Typography variant="body1" className={classes.valueText}>
                  {userDetail?.businessInfo?.import_export_code}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" alignItems="center" mb={1}>
                  <Payment color="primary" fontSize="small" sx={{ mr: 1 }} />
                  <Typography className={classes.labelText}>
                    Payment Methods
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {userDetail?.businessInfo?.payment_method?.map((method, index) => (
                    <Chip key={index} label={method} size="small" />
                  ))}
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" alignItems="center" mb={1}>
                  <LocalShipping
                    color="primary"
                    fontSize="small"
                    sx={{ mr: 1 }}
                  />
                  <Typography className={classes.labelText}>
                    Shipment Modes
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {userDetail?.businessInfo?.shipment_method?.map((mode, index) => (
                    <Chip key={index} label={mode} size="small" />
                  ))}
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  return (
    <Grid container>
      <MiniDrawer
        header="Company User Detail"
        children={
          <>
            <Grid container sx={{ mb: 3 }}>
              <Button
                variant="contained"
                startIcon={<ArrowBack />}
                onClick={() => navigate("/company-users")}
              >
                Back
              </Button>
            </Grid>

            {pageLoad ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "50vh",
                }}
              >
                <CircularProgress
                  style={{ color: BaseColor.primary }}
                  size={30}
                />
              </Box>
            ) : (
              <>
                <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={8}>
                      <Typography variant="h5" component="h1" fontWeight="bold">
                        {userDetail?.businessInfo?.name}
                      </Typography>
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mt: 1 }}
                      >
                        <LocationOn
                          fontSize="small"
                          sx={{ verticalAlign: "middle", mr: 0.5 }}
                        />
                        {userDetail?.businessInfo?.city}, {userDetail?.businessInfo?.state},{" "}
                        {userDetail?.businessInfo?.country}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>

                <Grid container spacing={{ xs: 2, sm: 3, md: 4, lg: 5, xl: 6 }}>
                  {renderCompanyInfo()}
                  {renderImageGallery()}
                </Grid>
              </>
            )}
          </>
        }
      />

      <CModal
        visible={confirm}
        title={"Delete user"}
        onClose={() => {
          setConfirm(false);
        }}
        children={
          <>
            <Grid container padding={"30px 0px"}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    marginBottom: 15,
                    fontFamily: FontFamily.SemiBold,
                    fontSize: 20,
                    textAlign: "center",
                  }}
                >
                  Are you sure you want to delete this user?
                </Typography>
              </Grid>
              <Grid container justifyContent={"center"} gap={2} wrap="nowrap">
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="outlined"
                    style={{ marginRight: "20px" }}
                    onClick={() => {
                      setConfirm(false);
                    }}
                  >
                    No
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <CButton
                    onClick={deleteUser}
                    fullWidth
                    variant="contained"
                    loading={yesBtnLoading}
                  >
                    Yes
                  </CButton>
                </Grid>
              </Grid>
            </Grid>
          </>
        }
      />

      <CModal
        visible={rejectModal}
        title={"Rejected Reason"}
        onClose={() => {
          setRejectModal(false);
          setRejectText();
        }}
        style={{ width: "40%" }}
        children={
          <div style={{ padding: "20px" }}>
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <CInput
                  placeholder="Enter Rejected Reason"
                  errorMsg={rejectErrorText}
                  onChange={(val) => {
                    setRejectText(val);
                  }}
                  value={rejectText}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={6} paddingRight={"10px"}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setRejectModal(false);
                    setRejectText();
                  }}
                  style={{ width: "100%" }}
                  disabled={disableBtn}
                >
                  No
                </Button>
              </Grid>

              <Grid item xs={6}>
                <CButton
                  variant="contained"
                  onClick={rejectUser}
                  style={{ width: "100%" }}
                  disabled={disableBtn}
                >
                  Yes
                </CButton>
              </Grid>
            </Grid>
          </div>
        }
      />

      <CPreviewModal ref={previewModalRef} />
    </Grid>
  );
}
